export default __webpack_public_path__ + "static/list1grid-img1-1512c26bac477a789736686d39c76854.jpg";